// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BookingDetailView.css */
.booking-detail-view-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
}

.booking-detail-view-container.slide-in {
  transform: translateX(0);
}

.booking-detail-view-header {
  position: fixed;
  top: 50px;
  height: 50px;
  background: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px); /* Apply a blur effect */
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 150;
  display: inline-block;
}


.booking-detail-view-header::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  height: 30px;
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0), var(--color-grey000)); 
}

.booking-detail-view {
  width: 100%;
  height: 100%;
  padding-top: 120px;
  padding-left: 0px;
  padding-bottom: 75px;
  background-color: white;
  overflow-y: auto;
  box-sizing: border-box;
}

.booking-detail-view-header-flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}

.booking-detail-view-icons-container {
  display: flex;
  align-items: center;
  padding-right: 25px;
  gap: 15px; 
}

.booking-detail-view-back-button {
  color: var(--color-grey100);
  z-index: 100;
  padding-left: 25px;
  font-size: 1.1em;
}

.booking-detail-view-icon {
  color: var(--color-grey100);
  margin-left: 15px; 
  cursor: pointer;  /* Optional: changes cursor on hover to indicate interactivity */
  font-size: 1.1em;
}
`, "",{"version":3,"sources":["webpack://./src/components/cardLists/BookingDetailView.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,mCAA2B;UAA3B,2BAA2B,EAAE,wBAAwB;EACrD,WAAW;EACX,wCAAwC;EACxC,YAAY;EACZ,qBAAqB;AACvB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iFAAiF;AACnF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe,GAAG,gEAAgE;EAClF,gBAAgB;AAClB","sourcesContent":["/* BookingDetailView.css */\n.booking-detail-view-container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 50;\n  transform: translateX(100%);\n  transition: transform 0.3s ease-in-out;\n}\n\n.booking-detail-view-container.slide-in {\n  transform: translateX(0);\n}\n\n.booking-detail-view-header {\n  position: fixed;\n  top: 50px;\n  height: 50px;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(10px); /* Apply a blur effect */\n  width: 100%;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 150;\n  display: inline-block;\n}\n\n\n.booking-detail-view-header::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  height: 30px;\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0), var(--color-grey000)); \n}\n\n.booking-detail-view {\n  width: 100%;\n  height: 100%;\n  padding-top: 120px;\n  padding-left: 0px;\n  padding-bottom: 75px;\n  background-color: white;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.booking-detail-view-header-flex-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.booking-detail-view-icons-container {\n  display: flex;\n  align-items: center;\n  padding-right: 25px;\n  gap: 15px; \n}\n\n.booking-detail-view-back-button {\n  color: var(--color-grey100);\n  z-index: 100;\n  padding-left: 25px;\n  font-size: 1.1em;\n}\n\n.booking-detail-view-icon {\n  color: var(--color-grey100);\n  margin-left: 15px; \n  cursor: pointer;  /* Optional: changes cursor on hover to indicate interactivity */\n  font-size: 1.1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
